// extracted by mini-css-extract-plugin
export default {"card":"Post_card__ljFVj","rating":"Post_rating__pXEYl","title":"Post_title__Rii2F","action":"Post_action__-NYQv","footer":"Post_footer__kNmZf"};